import { LssProp } from '@lucidhq/lucidium';

export const layoutContainerLss: LssProp = {
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  p: 'xxl',
  pb: 'xxxl',
  mobile: {
    px: 'xl',
  },
  tablet: {
    px: 'xxl',
  },
};

export const removePaddingsLss: LssProp = {
  p: 'none',
  pb: 'none',
  mobile: {
    px: 'none',
  },
  tablet: {
    px: 'none',
  },
};

export const fullLss: LssProp = {
  maxWidth: '100%',
};

export const largeLss: LssProp = {
  maxWidth: '80rem',
};

export const mediumLss: LssProp = {
  maxWidth: '60rem',
};

export const smallLss: LssProp = {
  maxWidth: '35rem',
};

export const centerLss: LssProp = {
  display: 'flex',
  justifyContent: 'center',
};
